export default __webpack_public_path__ + "static/media/83.926e985a.png";